<div class="page-content">

  <!-- ========================================================= -->
  <!-- HEADER -->
  <!-- ========================================================= -->

  <div class="page-header">

    <div>
      <h1>Ocorrências</h1>
      <p>
        {{ estatisticas.abertas }} abertas · {{ estatisticas.fechadas }} fechadas
      </p>
    </div>

    <div class="page-actions">
      <button
        class="btn-web-secondary"
        type="button"
        (click)="filtrosPainelAberto = true"
      >
        <i class="ri-filter-3-line"></i>
        Filtros
      </button>

      <button
        class="btn-web-primary"
        type="button"
        (click)="openNew()"
      >
        <i class="fas fa-plus"></i>
        Nova Ocorrência
      </button>
    </div>

  </div>

  <!-- ========================================================= -->
  <!-- FILTROS -->
  <!-- ========================================================= -->

  <div class="filters-row">

    <button
      type="button"
      class="filter-chip"
      [class.active]="activeCriticidadeFilter === 'TODAS'"
      (click)="setActiveCriticidade('TODAS')"
    >
      Todas ({{ estatisticas.totalOcorrencias }})
    </button>

    <button
      type="button"
      class="filter-chip red-chip"
      [class.active]="activeCriticidadeFilter === 'URGENTE'"
      (click)="setActiveCriticidade('URGENTE')"
    >
      <span class="prio-dot"></span>
      Urgente ({{ estatisticas.urgentes }})
    </button>

    <button
      type="button"
      class="filter-chip red-chip"
      [class.active]="activeCriticidadeFilter === 'ALTA'"
      (click)="setActiveCriticidade('ALTA')"
    >
      <span class="prio-dot"></span>
      Alta ({{ estatisticas.altas }})
    </button>

    <button
      type="button"
      class="filter-chip yellow-chip"
      [class.active]="activeCriticidadeFilter === 'MEDIA'"
      (click)="setActiveCriticidade('MEDIA')"
    >
      <span class="prio-dot"></span>
      Média ({{ estatisticas.medias }})
    </button>

    <select
      class="filter-select"
      (change)="onEstadoFilterChange($event)"
    >
      <option value="Todos">
        Todos os estados
      </option>
      <option value="ABERTA">
        Aberta
      </option>
      <option value="EM_PROGRESSO">
        Em Progresso
      </option>
      <option value="FECHADA">
        Fechada
      </option>
    </select>

  </div>

  <!-- ========================================================= -->
  <!-- TABELA -->
  <!-- ========================================================= -->

  <div class="data-table-wrapper">

    <p-menu
      #rowMenu
      [model]="menuItems"
      [popup]="true"
      appendTo="body"
    >
    </p-menu>

    <table
      class="data-table"
      *ngIf="!loading && ocorrencias.length > 0"
    >
      <thead>
        <tr>
          <th>ID</th>
          <th>Tipo</th>
          <th>Posto</th>
          <th>Prioridade</th>
          <th>Estado</th>
          <th>Registado por</th>
          <th>Data/Hora</th>
          <th>Ações</th>
        </tr>
      </thead>

      <tbody>
        @for (o of ocorrencias; track trackById($index, o)) {
          <tr
            [class]="
              'row-' +
              (
                getCriticidadeLabel(o.criticidade) || 'media'
              ).toLowerCase()
            "
          >
            <td>
              <strong>
                #OC-{{ o.id }}
              </strong>
            </td>

            <td>
              <div class="tipo-cell">
                <i [class]="getTipoIcon(o.tipoOcorrencia)"></i>
                <span>
                  {{ getTipoLabel(o.tipoOcorrencia) }}
                </span>
              </div>
            </td>

            <td>
              {{ getPostoNome(o) }}
            </td>

            <td>
              <span
                class="badge"
                [ngClass]="{
                  red:
                    getCriticidadeLabel(o.criticidade) === 'Urgente' ||
                    getCriticidadeLabel(o.criticidade) === 'Alta',
                  yellow:
                    getCriticidadeLabel(o.criticidade) === 'Média'
                }"
              >
                <span class="prio-dot"></span>
                {{ getCriticidadeLabel(o.criticidade) }}
              </span>
            </td>

            <td>
              {{
                o.estadoEnum === 1
                  ? 'Aberta'
                  : o.estadoEnum === 3
                    ? 'Em Progresso'
                    : 'Fechada'
              }}
            </td>

            <td>
              {{ getRegistadoPorNome(o) }}
            </td>

            <td>
              {{ o.dataOcorrencia | date: 'dd/MM HH:mm' }}
            </td>

            <td
              class="actions"
              (click)="$event.stopPropagation()"
            >
              <button
                type="button"
                class="btn-dots"
                [disabled]="detalheLoadingId === o.id"
                (click)="openRowMenu($event, o)"
                aria-label="Abrir ações da ocorrência"
                title="Ações"
              >
                <i
                  [class]="
                    detalheLoadingId === o.id
                      ? 'pi pi-spin pi-spinner'
                      : 'pi pi-ellipsis-v'
                  "
                ></i>
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>

    <!-- ======================================================= -->
    <!-- EMPTY -->
    <!-- ======================================================= -->

    <app-empty-state
      *ngIf="!loading && ocorrencias.length === 0"
      icon="fas fa-shield-alt"
      title="Sem ocorrências registadas"
      message="Não existem ocorrências registadas para os filtros selecionados."
    >
    </app-empty-state>

    <!-- ======================================================= -->
    <!-- LOADING -->
    <!-- ======================================================= -->

    <div *ngIf="loading" class="skeleton-rows">
      @for (i of [1, 2, 3, 4, 5]; track i) {
        <p-skeleton height="44px" styleClass="mb-2"></p-skeleton>
      }
    </div>

  </div>

  <!-- ========================================================= -->
  <!-- PAGINAÇÃO -->
  <!-- ========================================================= -->

  <div
    class="pagination-container"
    *ngIf="totalRecords > 0"
  >
    <app-paginator-control
      [first]="first"
      [rows]="pageSize"
      [totalRecords]="totalRecords"
      [rowsPerPageOptions]="[5, 10, 20, 50]"
      [alwaysShow]="true"
      [showCurrentPageReport]="true"
      (pageChange)="onPageChange($event)"
    >
    </app-paginator-control>
  </div>

  <!-- ========================================================= -->
  <!-- DRAWER CRIAR / EDITAR -->
  <!-- ========================================================= -->

  <p-drawer
    [(visible)]="showDialog"
    position="right"
    [modal]="true"
    [header]="editing ? 'Editar Ocorrência' : 'Registar Ocorrência'"
    [style]="{ width: 'min(90vw, 540px)' }"
    [closable]="true"
    styleClass="efetivo-drawer-dark"
    (onHide)="showDialog = false"
  >
    <form [formGroup]="form" class="dialog-form">

      <div class="form-group">
        <input #fotoOcorrenciaInput type="file" accept="image/*" hidden (change)="onFotoOcorrenciaChange($event)" />
        <button type="button" class="occurrence-photo-picker" (click)="fotoOcorrenciaInput.click()">
          <img *ngIf="fotoOcorrenciaPreview" [src]="fotoOcorrenciaPreview" alt="Foto da ocorrência" />
          <span *ngIf="!fotoOcorrenciaPreview" class="occurrence-photo-empty">
            <i class="fas fa-image"></i>
            <span>Adicionar Foto</span>
          </span>
          <span *ngIf="fotoOcorrenciaPreview" class="occurrence-photo-overlay"><i class="fas fa-camera"></i></span>
        </button>
      </div>

      <!-- TIPO + DATA -->
      <div class="form-grid-2">
        <div class="form-group">
          <label>
            Tipo de Ocorrência
            <span class="req">*</span>
          </label>

          <p-select
            formControlName="tipoOcorrencia"
            [options]="tipos"
            optionLabel="label"
            optionValue="value"
            placeholder="Seleccionar tipo"
            [styleClass]="'w-full' + (isFieldInvalid('tipoOcorrencia') ? ' ng-invalid ng-dirty' : '')"
            appendTo="body"
          >
            <ng-template pTemplate="selectedItem" let-t>
              <div class="tipo-opt" *ngIf="t">
                <i [class]="getTipoIcon(t.value)"></i>
                {{ t.label }}
              </div>
            </ng-template>

            <ng-template pTemplate="item" let-t>
              <div class="tipo-opt">
                <i [class]="getTipoIcon(t.value)"></i>
                {{ t.label }}
              </div>
            </ng-template>
          </p-select>

          <small class="field-error" *ngIf="isFieldInvalid('tipoOcorrencia')">
            {{ getFieldError('tipoOcorrencia') }}
          </small>
        </div>

        <div class="form-group">
          <label>
            Data / Hora
            <span class="req">*</span>
          </label>

          <p-datepicker
            [showIcon]="true"
            formControlName="dataOcorrencia"
            dateFormat="dd/mm/yy"
            [showTime]="true"
            [styleClass]="'w-full' + (isFieldInvalid('dataOcorrencia') ? ' ng-invalid ng-dirty' : '')"
            appendTo="body"
            [autoZIndex]="true"
            [baseZIndex]="1000010"
            panelStyleClass="drawer-datepicker-panel"
          >
          </p-datepicker>

          <small class="field-error" *ngIf="isFieldInvalid('dataOcorrencia')">
            {{ getFieldError('dataOcorrencia') }}
          </small>
        </div>
      </div>

      <!-- CRITICIDADE -->
      <div class="form-group">
        <label>
          Nível de Criticidade
          <span class="req">*</span>
        </label>

        <div
          class="crit-toggle"
          [class.is-invalid]="isFieldInvalid('criticidade')"
        >
          @for (c of criticidades; track c.value) {
            <button
              type="button"
              class="crit-btn"
              [ngClass]="c.css"
              [class.active]="form.get('criticidade')?.value === c.value"
              (click)="setCriticidade(c.value)"
            >
              <i [class]="c.icon"></i>
              {{ c.label }}
            </button>
          }
        </div>

        <small class="field-error" *ngIf="isFieldInvalid('criticidade')">
          {{ getFieldError('criticidade') }}
        </small>
      </div>

      <!-- POSTO + RONDA -->
      <div class="form-group">
        <label>
          Posto
          <span class="req">*</span>
        </label>

        <p-select
          formControlName="idPosto"
          [options]="postos"
          optionLabel="label"
          optionValue="value"
          placeholder="Seleccionar o posto"
          [showClear]="true"
          appendTo="body"
          [filter]="true"
          filterPlaceholder="Pesquisar..."
          (onChange)="onPostoChange($event.value)"
          [styleClass]="'w-full' + (isFieldInvalid('idPosto') ? ' ng-invalid ng-dirty' : '')"
        >
        </p-select>

        <small class="field-error" *ngIf="isFieldInvalid('idPosto')">
          Seleccione o posto.
        </small>
      </div>

      <div class="form-group">
        <label>
          Ronda da ocorrência
          <span class="req">*</span>
        </label>

        <p-select
          formControlName="idRonda"
          [options]="rondasFiltradas"
          optionLabel="label"
          optionValue="value"
          placeholder="Seleccionar a ronda"
          [showClear]="true"
          [disabled]="!form.get('idPosto')?.value"
          appendTo="body"
          [filter]="true"
          filterPlaceholder="Pesquisar..."
          [styleClass]="'w-full' + (isFieldInvalid('idRonda') ? ' ng-invalid ng-dirty' : '')"
        >
        </p-select>

        <small class="field-hint" *ngIf="form.get('idPosto')?.value && !rondasFiltradas.length">
          Não existem checkpoints/rondas associados ao posto seleccionado.
        </small>

        <small class="field-error" *ngIf="isFieldInvalid('idRonda')">
          {{ getFieldError('idRonda') }}
        </small>
      </div>

      <!-- DESCRIÇÃO -->
      <div class="form-group">
        <label>
          Descrição
          <span class="req">*</span>
        </label>

        <textarea
          pTextarea
          class="form-input"
          [class.ng-invalid]="isFieldInvalid('descricaoTipoOutro')"
          [class.ng-dirty]="isFieldInvalid('descricaoTipoOutro')"
          formControlName="descricaoTipoOutro"
          rows="4"
          placeholder="Descreva a ocorrência em detalhe: o que aconteceu, quando, quem estava envolvido..."
        ></textarea>

        <small class="field-error" *ngIf="isFieldInvalid('descricaoTipoOutro')">
          {{ getFieldError('descricaoTipoOutro') }}
        </small>
      </div>

    </form>

    <ng-template pTemplate="footer">
      <div class="occurrence-drawer-actions">
        <button
          type="button"
          class="btn-web-secondary"
          (click)="showDialog = false"
        >
          Cancelar
        </button>

        <button
          type="button"
          class="btn-web-primary"
          (click)="save()"
        >
          <i class="fas fa-save"></i>
          Guardar
        </button>
      </div>
    </ng-template>
  </p-drawer>

</div>

<!-- ============================================================= -->
<!-- FILTROS OVERLAY -->
<!-- ============================================================= -->

<div
  class="filtros-overlay"
  [class.open]="filtrosPainelAberto"
  (click)="filtrosPainelAberto = false"
>
</div>

<!-- ============================================================= -->
<!-- FILTROS DRAWER -->
<!-- ============================================================= -->

<div class="filtros-drawer" [class.open]="filtrosPainelAberto">

  <div class="filtros-header">
    <h3 class="fd-title">
      <i class="ri-equalizer-3-line"></i>
      Filtros de Ocorrências
    </h3>

    <button type="button" class="filtros-close-btn" (click)="filtrosPainelAberto = false">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="filtros-body" [formGroup]="filtrosForm">

    <div class="filtro-grupo">
      <label>Ronda</label>
      <p-select
        formControlName="IdRonda"
        [options]="rondas"
        optionLabel="label"
        optionValue="value"
        placeholder="Todas"
        styleClass="w-full"
        appendTo="body"
        [showClear]="true"
      >
      </p-select>
    </div>

    <div class="filtro-grupo">
      <label>Escala</label>
      <p-select
        formControlName="IdEscala"
        [options]="escalas"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccione a escala"
        styleClass="w-full"
        appendTo="body"
        [showClear]="true"
      >
      </p-select>
    </div>

    <div class="filtro-grupo">
      <label>Posto</label>
      <p-select
        formControlName="IdPosto"
        [options]="postos"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccione o posto"
        styleClass="w-full"
        appendTo="body"
        [showClear]="true"
      >
      </p-select>
    </div>

    <div class="filtro-grupo">
      <label>Efetivo</label>
      <p-select
        formControlName="IdEfetivo"
        [options]="efetivos"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccione o efetivo"
        styleClass="w-full"
        appendTo="body"
        [showClear]="true"
      >
      </p-select>
    </div>

    <div class="filtro-grupo">
      <label>Cliente</label>
      <p-select
        formControlName="IdCliente"
        [options]="clientes"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccione o cliente"
        styleClass="w-full"
        appendTo="body"
        [filter]="true"
        filterPlaceholder="Pesquisar..."
        [showClear]="true"
      >
      </p-select>
    </div>

    <div class="filtro-grupo">
      <label>Criticidade</label>
      <p-select
        formControlName="Criticidade"
        [options]="criticidades"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccione a criticidade"
        styleClass="w-full"
        appendTo="body"
        [showClear]="true"
      >
      </p-select>
    </div>

    <div class="filtro-grupo">
      <label>Tipo de ocorrência</label>
      <p-select
        formControlName="TipoOcorrencia"
        [options]="tipos"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccione o tipo"
        styleClass="w-full"
        appendTo="body"
        [showClear]="true"
      >
      </p-select>
    </div>

    <div class="filtro-grupo">
      <label>Data</label>
      <p-datepicker
        class="form-input"
        formControlName="Data"
        dateFormat="dd/mm/yy"
        appendTo="body"
        [showIcon]="true"
        [autoZIndex]="true"
        [baseZIndex]="1000010"
        panelStyleClass="drawer-datepicker-panel"
      >
      </p-datepicker>
    </div>

  </div>

  <div class="filtros-footer">
    <button
      type="button"
      class="btn-web-secondary"
      style="flex: 1"
      (click)="$event.preventDefault(); $event.stopPropagation(); limparFiltros()"
    >
      <i class="fas fa-undo"></i>
      Limpar
    </button>

    <button
      type="button"
      class="btn-web-primary"
      style="flex: 2"
      (click)="aplicarFiltrosDrawer()"
    >
      <i class="fas fa-check"></i>
      Aplicar
    </button>
  </div>

</div>

<!-- ============================================================= -->
<!-- DETALHE DA OCORRÊNCIA -->
<!-- ============================================================= -->

<app-detalhe-ocorencia
  [(visible)]="showDetalheOcorrencia"
  [occurrence]="ocorrencia"
  [podeFechar]="auth.hasRole('FECHAR_OCORRENCIA') && ocorrencia?.estadoEnum !== 2"
  [podeReabrir]="auth.hasRole('REABRIR_OCORRENCIA') && ocorrencia?.estadoEnum === 2"
  (fechar)="openFecharOcorrencia(ocorrenciaListaSelecionada || ocorrencia)"
  (reabrir)="confirmReabrir(ocorrenciaListaSelecionada || ocorrencia)"
>
</app-detalhe-ocorencia>

<app-fechar-ocorrencia
  [(visible)]="showFecharOcorrencia"
  [ocorrencia]="ocorrenciaAEncerrar"
  (fechada)="onOcorrenciaFechada($event)"
>
</app-fechar-ocorrencia>
